import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'icc-multi-line-cell',
  templateUrl: './icc-multi-line-cell.component.html',
  styles: [],
})
/*
该组件类用于多行显示数据，其title数据默认为自动换行，后期如有需要，再分离出来
* */
export class IccMultiLineCellComponent implements OnInit {
  @ViewChild('rolesTitleTemplate', { static: false }) cellTitle;
  @Input() list: any = [];
  @Input() lines = 0;
  htmlStr = '';
  constructor(private el: ElementRef) {}

  ngOnInit() {
    const $el = $(this.el.nativeElement);
    this.htmlStr = this.multiLineDisplay(this.list, 0);
    $el.find('.cell-label')[0].innerHTML = this.multiLineDisplay(this.list, this.lines);
  }

  multiLineDisplay(list, rows) {
    let resultStr = '';
    let br = '<br />';
    if (list && list instanceof Array) {
      for (let i = 0; i < list.length; i++) {
        if (rows <= 0) {
          resultStr += list[i].name + br;
        } else if (i < rows) {
          resultStr += list[i].name + br;
        } else {
          resultStr = resultStr.slice(0, resultStr.length - br.length) + '...';
          break;
        }
      }
      if (rows <= 0 || list.length <= rows) {
        resultStr = resultStr.slice(0, resultStr.length - br.length);
      }
    }
    return resultStr;
  }
}
